<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true" id="join-modal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <i class="fas fa-plus-circle"></i>
                        本文糾合
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group episode-block">
                        <label>
                            <span v-if="current" v-html="$filters.ruby(current.section_name)"></span>
                            <span v-if="current">( {{$filters.numberFormat(current.characters)}}文字 )</span>
                        </label>
                        <div class="my-2 small" v-html="$filters.ruby(currPart)"></div>
                    </div>
                    <div>
                        <h3 class="text-center">
                            <i class="fas fa-plus-circle"></i>
                        </h3>
                    </div>
                    <div class="form-group episode-block">
                        <label>
                            <span class="deleted" v-if="next && next.id" v-html="$filters.ruby(next.section_name)"></span>
                            <span v-else>本文無し</span>
                            <span v-if="next && next.id">( {{$filters.numberFormat(next.characters)}}文字 )</span>
                        </label>
                        <div class="my-2 small" v-if="next && next.body" v-html="$filters.ruby(nextPart)"></div>
                        <div class="my-2 text-danger small" v-else>次の本文がありません。</div>
                    </div>
                    <div class="text-muted">
                        本文を糾合すると、次の本文は現在の本文に結合されます。
                        次のエピソードは削除されます。
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">閉じる</button>
                    <button type="button" class="btn btn-outline-primary" @click="joinEpisode()" :disabled="noSave">本文を糾合する</button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.episode-block {
    padding: .5rem;
    border: 3px solid #ddd;
    border-radius: .5rem;
}
.deleted {
    text-decoration: line-through;
}
</style>

<script>
export default {
    props: {
        id: {
            required: true
        },
        current: {
            required: true,
        }
    },
    data() {
        return {
            next: {},
        }
    },
    methods: {
        load() {
            axios.get("/mypage/book/sections/next", {params: {id: this.id}}).then(res => {
                this.next = res.data;
            }).catch(err => { alert.err(err.response) });
        },
        joinEpisode() {
            axios.post("/mypage/book/sections/join", {id: this.id}).then(res => {
                alert.msg(res.data);
                this.$emit("saved");
                $("#join-modal").modal("hide");
            }).catch(err => { alert.err(err.response) });
        }
    },
    computed: {
        currPart() {
            if (!this.current?.body) return "";
            const part = this.current.body.replace(/[|｜]|《[^》]+》/gu, "");
            if (part?.length > 200) {
                return "..." + part.substr(-200);
            }
            return part;
        },
        nextPart() {
            if (!this.next?.body) return "";
            const part = this.next.body.replace(/[|｜]|《[^》]+》/gu, "");
            if (part?.length > 200) {
                return part.substr(0, 200) + "...";
            }
            return part;
        },
        noSave() {
            if (!this.next?.body) {
                return true;
            }
            return false;
        }
    },
    mounted() {
        $("#join-modal").on("show.bs.modal", (e) => {
            this.load();
        });
    },
}
</script>